import { render, staticRenderFns } from "./RideConnectedUsers.vue?vue&type=template&id=198be9ec&scoped=true"
import script from "./RideConnectedUsers.vue?vue&type=script&lang=js"
export * from "./RideConnectedUsers.vue?vue&type=script&lang=js"
import style0 from "./RideConnectedUsers.vue?vue&type=style&index=0&id=198be9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198be9ec",
  null
  
)

export default component.exports